import { createSectionFactory } from "@hydrologiq/shared/createSection"
import { Section } from "@hydrologiq/shared/providers/CopyProvider"
import Routing from "@hydrologiq/systems/Routing"
import { graphqlUri, graphqlUriLegacy, graphqlUriPrimary, restEndpoint } from "./config"
import systemCss from "./index.scss?inline" // Import all SCSS files


// Create the section using the generic factory
const createSection = createSectionFactory({
  sectionName: "systems",
  section: Section.SYSTEMS,
  RoutingComponent: Routing,
  graphqlUri,
  restEndpoint,
  sectionCss: systemCss, // Include all section SCSS
  // Configure dual GraphQL endpoints for systems migration
  primaryGraphqlUri: graphqlUriPrimary,
  legacyGraphqlUri: graphqlUriLegacy,
})

export default createSection
